<template>
    <article class='xbed-oms-content'>
        <section class='xbed-sub-title'>
            <span>推广报表</span>
        </section>
        <section style='marginTop:20px'>
            <Form :model='transaction' ref='transaction'>
                <Row>
                    <Col span='4'>
                        <FormItem prop='' label='渠道' :label-width='45'>
                            <Select v-model='transaction.channel'>
                                <Option v-for='status in chanelList' :key='status.channel' :value='status.channel'>{{status.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span='7'>
                        <FormItem prop='' label='注册时间' :label-width='100'>
                            <date-picker type='daterange' :model='dateParams.datePick' :value='dateParams.datePick' @on-change="datepickReg" style='width:100%'></date-picker>
                        </FormItem>
                    </Col>
                    <Col span='7'>
                        <FormItem prop='' label='消费时间' :label-width='100'>
                            <date-picker type='daterange' :model='dateParams.datePick' :value='dateParams.datePick' @on-change="datepickCon" style='width:100%'></date-picker>
                        </FormItem>
                    </Col>
                    <Col span='1' style="margin: 0 20px;">
                        <FormItem>
                            <Button type='primary' @click='queryReportList'>查询</Button>
                        </FormItem>
                    </Col>
                    <Col span='1' v-if='isShowExportBtn'>
                        <FormItem>
                            <Button class="ml-2" type='primary' @click='exportList'>导出</Button>
                        </FormItem>
                    </Col>
                </Row>
                <Table stripe :loading='transactionLoading' :width="tableWidth"  height="650" :columns="transactionList" :data="transactionData.list">
                </Table>
                <div style="margin: 10px;overflow: hidden">
                    <Page show-sizer placement="top" :total="transactionData.total" :current="transaction.page_num" :page-size="transaction.page_size" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
                </div>
            </Form>
        </section>
    </article>
</template>
<script>
import Moment from 'moment';
// import {phoneRegular} from "../../utils/regular"
import API from "../../api";
import Utils from '../../utils';

export default{
    data (){
        return {
            tableWidth: 0,
            chanelList:[
                {
                    channel: 0,
                    name: '全部'
                }
            ],
            isShowExportBtn: true,
            transaction:{
                channel: '',
                con_begin_date: Moment().subtract(29, 'days').format('YYYY-MM-DD'),
                con_end_date: Moment().format('YYYY-MM-DD'),
                reg_begin_date: Moment().subtract(29, 'days').format('YYYY-MM-DD'),
                reg_end_date: Moment().format('YYYY-MM-DD'),
                page_num: 1,
                page_size: 10
            },
            dateParams: {
                datePick:[Moment().subtract(29, 'days').format('YYYY-MM-DD'),  Moment().format('YYYY-MM-DD')],
            },
            transactionData:{
                list:[]
            },
            transactionLoading: false,
            transactionList:[
                {
                    title:'渠道',
                    key:'source_name',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'推广人员',
                    key:'marketer_code',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'省份',
                    key:'province',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'城市',
                    key:'city',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'首销会员数（艺龙）',
                    key:'first_cost_member_count',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'消费会员数（艺龙）',
                    key:'all_cost_member_count',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'优惠（元）',
                    key:'coupon_discount_amount',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'艺龙订单金额',
                    key:'total_price',
                    minWidth:150,
                    align: 'center',
                },
                {
                    title:'总房晚（艺龙）',
                    key:'number_of_rooms',
                    minWidth:150,
                    align: 'center',
                }
            ]
        }
    },
    methods:{
        datepickReg(dataArr){
            // 注册开始时间
            this.transaction.reg_begin_date = dataArr[0];
            this.transaction.reg_end_date = dataArr[1];
            console.info(this.transaction);
        },
        datepickCon(dataArr){
            // 消费开始时间
            this.transaction.con_begin_date = dataArr[0];
            this.transaction.con_end_date = dataArr[1];
            console.info(this.transaction);
        },
        async exportList() {
            this.transaction.page_num = 1;
            this.transactionLoading = true;

            let elongUrl = API.omsAPI[this.env].elong.gatewayClient.gatewayUrl + 'api/v1/elong/oms/elong-marketer-report-export'
            let path = `${elongUrl}?channel=${this.transaction.channel}&con_begin_date=${this.transaction.con_begin_date}&con_end_date=${this.transaction.con_end_date}&page_num=${this.transaction.page_num}&page_size=${this.transaction.page_size}&reg_begin_date=${this.transaction.reg_begin_date}&reg_end_date=${this.transaction.reg_end_date}`
            window.location.href = path

            let respData = (await API.omsAPI[this.env].elong.elongMarketerExport(this.transaction, this.token)).data;
            console.info('exportList', respData, path)
            this.transactionLoading = false;
        },
        async queryReportList(){
            this.transaction.page_num = 1;
            this.transactionLoading = true;
            let respData = (await API.omsAPI[this.env].elong.elongMarketerReport(this.transaction, this.token)).data;
            this.transactionData = respData.data;
            this.transactionLoading = false;
        },
        async changePage(pageIndex) {
            this.transaction.page_num = pageIndex;
            this.transactionLoading = true;
            let respData = (await API.omsAPI[this.env].elong.elongMarketerReport(this.transaction, this.token)).data;
            this.transactionData = respData.data;
            this.transactionLoading = false;
        },
        changePageSize(pageSize){
            this.transaction.page_num = 1;
            this.transaction.page_size = pageSize;
        },
        async getChanel() {
            this.transactionLoading = true;
            let respData = (await API.omsAPI[this.env].php.elongMarketerChannel()).data.retdata;
            let msg = {}
            if (respData) {
                respData.map(item => {
                    msg = {
                        channel: item.channel.split(' - ')[0],
                        name: item.channel.split(' - ')[1]
                    }
                    if (msg.name === '空港七天') {
                        this.transaction.channel = msg.channel
                        this.queryReportList()
                    }
                    this.chanelList.push(msg)
                })
            }
            this.transactionLoading = false;
        }
    },
    created(){
        this.token = Utils.findFromLocalStorage('vue-token');
        this.env = Utils.findFromLocalStorage('env','dev');
        this.userId = Utils.findFromLocalStorage('vue-userid');
        this.tableWidth = window.screen.width - 235;
        if (!Utils.hasPermission('Elong_promotionReport')) {
          this.isShowExportBtn = false;
        }
        console.info('Elong_promotionReport', !Utils.hasPermission('Elong_promotionReport'))
        this.getChanel();
    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/elong/promotionReport.vue